<template>
    <div v-loading="loading" class="fundation-dashboard">
        <app-header></app-header>

        <!-- Left side column. contains the sidebar -->


        <app-sidebar class="transition">
            <template slot="sidebar-menu-0">
                <slot name="sidebar-menu-1">
                </slot>
            </template>
        </app-sidebar>

        <!-- Content Wrapper. Contains page content -->
        <div
            :class="{ expansion: burgerMenuAllowedAndClosed}"
            class="view transition"
        >
            <router-view></router-view>
        </div>
    <!-- /.content-wrapper -->

    <!-- <app-footer></app-footer> -->

    <!-- <control-sidebar ></control-sidebar> -->
    </div>
</template>

<script>
import Sidebar from './Sidebar.vue';
import Header from './Header.vue';
// import Footer from './Footer.vue'
// import ControlSidebar from './ControlSidebar.vue'
import { mapGetters } from 'vuex';
export default {
    name: 'Layout',
    components: {
        'app-sidebar': Sidebar,
        'app-header': Header,
    },
    data(){
        return {
            loading: false,
        };
    },
    computed: {
        ...mapGetters('fundation', [
            'burgerMenuAllowedAndClosed',
        ]),
    }
};
</script>

<style lang="scss">
.fundation-dashboard {
  .view {
    background-color: #ebebeb;
    height: 100%;
    div {
      transition: .3s ease-in-out margin-left;
    }
    // .main-layout {
    //   .main {
    //     transition: .3s ease-in-out margin-left;
    //   }
    // }
  }
  .transition {
    // removed as there is already a margin in `content-wrapper`, still need to test
    // on a dashboard v1
    // min-height: calc(100vh - 65px); // 65px == app-header size
    ;
    transition: 1s padding-top;
  }
  .moving {
    padding-top: 32px;
  }
  .expansion {
    transition: .3s ease-in-out margin-left;
    .content-wrapper {
        margin-left: 60px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/layouts/dashboard/index.vue